import { OPEN_LOADER, FALSE_LOADER, UPDATE_ALERT, UPDATE_ALERT_CLOSE, OPEN_ORDER_SUCCESS, CLOSE_ORDER_SUCCESS } from "../../actionTypes/spinner";

const intialState = {
  isLoader: false,
  isAlert: false,
  message: '',
  color: '',
  spinnerCount: 0,
  isOrderSuccess: false,
  orderSuccess: {}
};

export default function LoaderReducers(state = intialState, action) {
  switch (action.type) {

    case OPEN_LOADER:
      return { ...state, isLoader: action.payload, spinnerCount: state.spinnerCount + 1 };

    case FALSE_LOADER:
      return { ...state, isLoader: action.payload, spinnerCount: state.spinnerCount - 1 };

    case UPDATE_ALERT:
      return { ...state, isAlert: true, message: action.message, color: action.color };

    case UPDATE_ALERT_CLOSE:
      return { ...state, isAlert: false};

    case OPEN_ORDER_SUCCESS:
      return { ...state, isOrderSuccess: true, orderSuccess: action.order };

    case CLOSE_ORDER_SUCCESS:
      return { ...state, isOrderSuccess: false };

    default:
      return state;
  }
}
